import { render, staticRenderFns } from "./Http404.vue?vue&type=template&id=493d5254&scoped=true&"
import script from "./Http404.vue?vue&type=script&lang=js&"
export * from "./Http404.vue?vue&type=script&lang=js&"
import style0 from "./Http404.vue?vue&type=style&index=0&id=493d5254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d5254",
  null
  
)

export default component.exports